import React from "react";

export default function AboutUsHeroSection() {
  return (
    <section className="about-hero">
      <div className="about-hero__inner">
        <div className="about-hero__badge">
          <img
            src="/icons/info-circle.svg"
            alt=""
            aria-hidden="true"
            className="about-hero__badge-icon"
          />
          About Highwatch AI
        </div>
        <h1>We&apos;re building the trusted intelligence layer for your enterprise.</h1>
        <p className="about-hero__sub">
          Highwatch AI unifies knowledge, workflows, and compliance across your systems, giving
          every team instant, secure access to the information that drives performance. Behind the
          platform is a team obsessed with clarity, privacy, and measurable enterprise impact.
        </p>
        <div className="about-hero__stats">
          <span>ROI in &lt; 90 Days</span>
          <span>SOC 2 &amp; GDPR Aligned</span>
          <span>50+ Enterprise Integrations</span>
        </div>
      </div>
    </section>
  );
}
